export default {
  adyenInputsWrapperSpan: Styles.color.black,
};
